import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {DescontoEspecialProduto} from '../../../../server/domain/DescontoEspecialProduto';
import {DescontoFormaPagamento} from '../../../../server/domain/DescontoFormaPagamento';

@Component({
  selector: 'app-descontos-especiais-produto',
  templateUrl: './descontos-especiais-produto.component.html',
  styleUrls: ['./descontos-especiais-produto.component.scss']
})
export class DescontosEspeciaisProdutoComponent implements OnChanges {
  @Input() produtoId: number;
  @Input() empresaId: number;
  @Input() descontos: DescontoEspecialProduto[] = [];
  @Input() podeEditar = false;
  @Input() carregando = false;
  @Input() erroCarregamento = '';
  @Output() recarregar = new EventEmitter<void>();
  @Output() descontosChange = new EventEmitter<DescontoEspecialProduto[]>();
  linhas: DescontoEspecialProduto[] = [];
  @Input() salvando = false;
  erro = '';
  editando: number[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if(!changes.produtoId && !changes.empresaId && !changes.descontos) return;
    if(this.descontos === this.linhas) return;
    this.linhas = (this.descontos || []).map(linha => ({...linha, ativo: !!linha.ativo}));
    this.erro = '';
    this.editando = [];
  }

  editarPercentual(linha: DescontoEspecialProduto): void {
    if(!this.podeEditar || !linha.ativo || this.salvando) return;
    const id = linha.formaDePagamentoId;
    this.editando = this.editando.includes(id) ? this.editando.filter(atual => atual !== id) : [...this.editando, id];
  }

  usarPadrao(linha: DescontoEspecialProduto): void {
    if(!this.podeEditar || !linha.ativo || this.salvando) return;
    linha.percentual = null;
    this.editando = this.editando.filter(id => id !== linha.formaDePagamentoId);
    this.alterou();
  }

  alterou(): void {
    if(!this.podeEditar || this.salvando) return;
    this.erro = '';
    try {
      for(const linha of this.linhas.filter(l => l.ativo))
        DescontoFormaPagamento.valideConfiguracao({modoDesconto: 'PRODUTOS', possuiDesconto: true,
          desconto: linha.percentualPadrao, descontosProdutos: [{produtoId: this.produtoId, percentual: linha.percentual}]});
    } catch(erro) {
      this.erro = erro?.message || String(erro);
    }
    this.descontosChange.emit(this.linhas);
  }
}
